import { render, staticRenderFns } from "./InsuranceSkladUsaTableUser.vue?vue&type=template&id=7b406567&scoped=true"
import script from "./InsuranceSkladUsaTableUser.vue?vue&type=script&lang=js"
export * from "./InsuranceSkladUsaTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b406567",
  null
  
)

export default component.exports